import Immutable from 'immutable';

const IdpParticipationRecord = Immutable.Record({
  id: undefined,
  name: undefined,
});

class IdpParticipation extends IdpParticipationRecord { }

export default IdpParticipation;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/IdpParticipation/model.js